import {startCase, toLower} from 'lodash';

export function humanizeEnumValue(value: string): string {
	return startCase(toLower(value));
}